<section>
  @if (loading) {
    <div class="flex w-full items-center justify-center">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else {
    <div class="m-auto h-[200px] w-[500px]">
      <canvas
        class="drop-shadow-md"
        baseChart
        [data]="{
          labels: pieChartData.labels,
          datasets: [
            {
              label: 'Orders',
              data: pieChartData.datasets[0].data,
              backgroundColor: backgroundColor,
              hoverOffset: 4,
            },
          ],
        }"
        [labels]="pieChartData.labels"
        [type]="pieChartType"
        [options]="pieChartOptions"
        (chartClick)="chartClicked($event)"
        [type]="'pie'"
      >
      </canvas>
    </div>
  }
</section>
